import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  accountData: {
    defaultMessage: 'Choose your payment account in the next step',
    id: 'AddCredentialsPage.accountData',
  },
  accountBalance: {
    defaultMessage: 'The account balance is private.',
    id: 'AddCredentialsPage.accountBalance',
  },
});
